import React from 'react';
import { DialogPrimaryButton, DialogSecondaryButton } from '@apps/admin/routes/Dashboard/common/commonDialog.styles';
import { ProductSelectionDialogFooterProps } from './ProductSelectionDialogFooter.types';

export const ProductSelectionDialogFooter: React.FC<ProductSelectionDialogFooterProps> = ({ saveLabel, cancelLabel, onCancel, onSave, isSaving }) => {
  return (
    <>
      <DialogSecondaryButton onClick={onCancel}>{cancelLabel}</DialogSecondaryButton>
      <DialogPrimaryButton disabled={isSaving} onClick={onSave} loading={isSaving}>
        {saveLabel}
      </DialogPrimaryButton>
    </>
  );
};
